module.exports = __webpack_public_path__ + "img/couples-044.517190a6.jpg";